import { render, staticRenderFns } from "./UCTabContent.vue?vue&type=template&id=0c402a64&scoped=true&"
import script from "./UCTabContent.vue?vue&type=script&lang=ts&"
export * from "./UCTabContent.vue?vue&type=script&lang=ts&"
import style0 from "./UCTabContent.vue?vue&type=style&index=0&id=0c402a64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c402a64",
  null
  
)

export default component.exports